/**
 * Block deprecation
 *
 * This file handles deprecated versions of the Featured Book block to maintain
 * backward compatibility when block structure or attributes change.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

/**
 * Version 1 deprecation
 * 
 * This represents the first version of the Featured Book block.
 * 
 * @const {Object} v1
 */
const v1 = {
  supports: {
    anchor: true,    
    html: false      
  },
  
  attributes: {
    isFeaturedBook: {
      default: true,
      type: 'boolean'
    },
    isbn: {
      default: '',
      type: 'string'
    },
    format: {
      default: '',
      type: 'string'
    },
    division: {
      default: '',
      type: 'string'
    },
    imprint: {
      default: '',
      type: 'string'
    },
    categories: {
      default: '',
      type: 'string'
    },
    workId: {
      default: '',
      type: 'number'
    },
    apiImage: {
      default: '',
      type: 'string'
    },
    uploadedImage: {
      default: {},
      type: 'object'
    },
    altTextManual: {
      default: '',
      type: 'string'
    },
    bookTitle: {
      default: '',
      type: 'string'
    },
    contributors: {
      default: '',
      type: 'string'
    },
    description: {
      default: '',
      type: 'string'
    },
    backgroundStyle: {
      default: 'default',
      type: 'string'
    },
    backgroundColor: {
      default: '',
      type: 'string'
    },
    titleColor: {
      default: '',
      type: 'string'
    },
    contributorsColor: {
      default: '',
      type: 'string'
    },
    descriptionColor: {
      default: '',
      type: 'string'
    },
    linkColor: {
      default: '',
      type: 'string'
    },
    showTitle: {
      default: true,
      type: 'boolean'
    },
    showContributors: {
      default: true,
      type: 'boolean'
    },
    showDescription: {
      default: true,
      type: 'boolean'
    },
    showReadMore: {
      default: true,
      type: 'boolean'
    },
    showCTA: {
      default: false,
      type: 'boolean'
    },
    uniqueId: {
      default: '',
      type: 'string'
    }
  },
  
  /**
   * Save function for v1
   * 
   * This would contain the exact save function from v1 of the block
   * Currently returns null as placeholder - would need actual v1 save logic
   * 
   * @param {Object} props 
   * @param {Object} props.attributes 
   * @return {WPElement|null} 
   */
  save({ attributes }) {
    return null;
  }
};

/** @const {Array} deprecated */
export default [ v1 ];
